var render = function render(){var _vm=this,_c=_vm._self._c;return _c('elwrapper',{attrs:{"label":"Signature","texttop":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.signature)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }